import { z } from 'zod'

import { OnboardingFlow } from '@/auth/flows'
import { emailSchema } from '@/utility'

export const googleProfileSchema = z
  .object({
    email: emailSchema,
    name: z.string().min(1),
    picture: z.string().optional(),
    email_verified: z.boolean(),
  })
  .meta({ id: 'google-profile' })

export const githubProfileSchema = z
  .object({
    login: z.string(),
    name: z.string().optional().nullable().default(null),
    email: emailSchema.optional().nullable().default(null),
    avatar_url: z.string().optional().nullable().default(null),
  })
  .meta({ id: 'github-profile' })

export const oauthStateSchema = z
  .object({
    uid: z.string(),
    redirect: z.string(),
    signupDataUid: z.string().optional(),
    teamInvite: z.string().optional(),
    flow: z.enum(OnboardingFlow).optional(),
  })
  .meta({ id: 'oauth-state' })
